import {
  QuestionInputType,
  QuestionInputTypeType,
  SurveyQuestion,
} from '../../models';

/**
 * Check if the question is just a text to display.
 */
export function isNoQuestion(question: SurveyQuestion) {
  // those widgets are used as hacks to display a paragraph with no real question
  return (
    (
      [
        QuestionInputType.radio,
        QuestionInputType.select,
      ] as QuestionInputTypeType[]
    ).includes(question.input_type) && !question.options?.length
  );
}

export function isConditional(question: SurveyQuestion) {
  return !!question.display_condition?.ref;
}

export function shouldAutoScrollQuestions(questions: SurveyQuestion[]) {
  return (
    questions.length &&
    questions.every(({ input_type }) => input_type === QuestionInputType.radio)
  );
}
